<template>
	<modal-container
		ref="modal"
		width="90%"
		maxWidth="700px"
	>
		<template slot="modal-content">
			<div id="google-contacts">
				<div class="flex top-panel">
					<input class="" type="text" placeholder="Cerca" v-model="search">
				</div>

				<div class="view-panel">
					<table class="tabel">
						<tr v-for="(record, index) in emails" v-if="found(record)" :key="index">
							<td class=""><input type="checkbox" :value="record.email" v-model="mailsToSend"></td>
							<td class="td-name">{{ record.name }}</td>
							<td class="td-email">{{ record.email }}</td>
						</tr>
					</table>
				</div>

				<div class="flex bottom-panel">
					<div><label><input type="checkbox" @click="selectAll()" v-model="allMailsSelected"> Scegli tutti</label></div>
					<CTA
						:size="`small`"
						:content="`Invia ${ count }`"
						@click="send()"
						:disabled="count <= 0"
					/>
				</div>
			</div>

		</template>
	</modal-container>
</template>

<script>
import $ from 'jquery'
import { UserApi } from '../../api/UserApi'

export default {

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data () {
		return {
			search: '',
			response: null,
			emails: null,

			allMailsSelected: false,

			mailsToSend: []
		}
	},

	computed: {
		count () {
			return this.mailsToSend.length
		}
	},

	methods: {
		close () {
			this.$refs.modal.close()
		},

		open () {
			this.$getGapiClient().then(gapi => {
				var config = {
					'client_id': '305491188209-jfu15boja7pkbqmc68u98bmb6v3hn9c0.apps.googleusercontent.com',
					'scope': 'https://www.googleapis.com/auth/contacts.readonly'
				}
				gapi.auth.authorize(config, () => {
					this.fetch(gapi.auth.getToken())
				})
			})
		},

		found (record) {
			if (!this.search) return true
			return record.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 || record.email.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
		},

		fetch (token) {
			$.ajax({
				url: 'https://www.google.com/m8/feeds/contacts/default/full?access_token=' + token.access_token + '&alt=json'
				// dataType: "jsonp",
			}).then(data => {
				// var response = JSON.stringify(data)
				var emails = []
				data.feed.entry.forEach(r => {
					if (r.gd$email) {
						r.gd$email.forEach(e => {
							var name = r.title.$t || e.address
							var user = {
								name: name,
								email: e.address
							}
							emails.push(user)
						})
					}
				})

				this.emails = emails
				this.$refs.modal.open()
			})
		},

		selectAll () {
			if (!this.allMailsSelected) {
				this.mailsToSend = []
				this.emails.forEach(email => {
					this.mailsToSend.push(email.email)
				})
			} else {
				this.mailsToSend = []
			}
		},

		send () {
			this.apiCalls().then(response => {
				this.close()
				this.$emit('success')
			}).catch(response => {
			})
		},

		apiCalls () {
			var um = new UserApi()
			var promises = []

			this.mailsToSend.forEach(mail => {
				promises.push(new Promise((resolve, reject) =>
					um.invite({email: mail}).then(_ => {
						resolve(_)
					})
				))
			})

			return Promise.all(promises)
		}
	}
}

</script>

<style scoped>
.top-panel {
	border-bottom: 1px solid #ededed;
	padding-bottom: 20px;
}

.bottom-panel {
	justify-content: space-between;
	align-items: middle;
	border-top: 1px solid #ededed;
	padding-top: 20px;
}

.view-panel {
	overflow-y: auto;
	max-height: calc(100vh - 170px);
	margin: 20px 0;
}

#google-contacts {
	font-size: 14px;
	width: 100%;
}

.tabel {
	padding: 20px 0;
}

#google-contacts td {
	padding: 4px 4px 4px 0;
}

#google-contacts input[type="checkbox"],
.check-all input {
	height: 15px;
	width: 15px;
	border-radius: 2px;
	border: 1px solid #5d5c5c;
	vertical-align: sub;
	margin-right: 5px;
}

.td-email, .td-name {
	max-width: 225px;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 47%;
	text-align: left;
}
</style>
